import ModuleGuard from '@/components/Guards/ModuleGuard';
import MODULES from '@/config/modules.config';
import { ChevronDownIcon } from '@/icons';
import { Button, DatePicker, Tooltip } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

interface Props {
  dates: [Dayjs | null, Dayjs | null];
  setDates: (dates: [Dayjs | null, Dayjs | null]) => void;
  onOpenRoleDrawer: () => void;
  onNavigateToPolicies: () => void;
}

export default function SummaryHeader({
  dates,
  setDates,
  onOpenRoleDrawer,
  onNavigateToPolicies,
}: Props) {
  return (
    <div className="dark:bg-theme-slate-800 border dark:border-theme-gray-700 p-3 rounded-xl w-full max-w-full mx-auto">
      <div className="flex flex-wrap justify-center xl:justify-between items-center gap-3">
        <div className="relative inline-flex items-center text-white cursor-pointer">
          {/* TEXT */}
          <span className="text-white text-xl lg:text-2xl xl:text-3xl font-bold">
            {dates[0]?.format("MMMM DD")} - {dates[1]?.format("MMMM DD")}
          </span>

          <ChevronDownIcon className="ml-2 text-white size-5 md:size-10 lg:size-12 cursor-pointer" />

          {/* HIDDEN RANGE PICKER */}
          <RangePicker
            value={dates}
            onChange={(val) => setDates(val as [Dayjs | null, Dayjs | null])}
            popupClassName="custom-dark-picker"
            className="absolute inset-0 opacity-0 cursor-pointer"
            allowClear={false}
            disabledDate={(current) => {
              return current && current > dayjs().endOf("day");
            }}
            showNow={false}
          />
        </div>

        <div className="flex gap-3 justify-end filter-section">
          <ModuleGuard
            moduleId={MODULES.CONTROL_PANEL_ROLE_PERMISSION}
            fallback={
              <Tooltip
                title="You don't have permission to access this feature"
                placement="bottom"
                mouseEnterDelay={0}
              >
                <Button size="large" disabled className="btn-primary">
                  Create Role
                </Button>
              </Tooltip>
            }
          >
            <Button
              size="large"
              className="btn-primary"
              onClick={onOpenRoleDrawer}
            >
              Create Role
            </Button>
          </ModuleGuard>
          <ModuleGuard
            moduleId={MODULES.CONTROL_PANEL_POLICIES}
            fallback={
              <Tooltip
                title="You don't have permission to access this feature"
                placement="bottom"
                mouseEnterDelay={0}
              >
                <Button size="large" disabled className="btn-primary-bordered">
                  Configure Policy
                </Button>
              </Tooltip>
            }
          >
            <Button
              size="large"
              onClick={onNavigateToPolicies}
              className="btn-primary-bordered"
            >
              Configure Policy
            </Button>
          </ModuleGuard>
        </div>
      </div>
    </div>
  );
}
